// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Y7M7QIYui3BoY91QIHtc{cursor:pointer;float:left}", "",{"version":3,"sources":["webpack://./src/p5lab/AnimationTab/item-loop-toggle.module.scss"],"names":[],"mappings":"AAAA,sBACE,cAAA,CACA,UAAA","sourcesContent":[".loopToggle {\n  cursor: pointer;\n  float: left;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loopToggle": "Y7M7QIYui3BoY91QIHtc"
};
export default ___CSS_LOADER_EXPORT___;
